import React from 'react';
import './Footer.scss';
import DisclaimerComponent from '@zappy-ride/disclaimer-footer-component';
import { FormattedMessage } from 'react-intl';
import FooterTop from '../../../assets/images/Footer-top-border.svg';
import DisclaimerLogo from '../../../assets/images/disclaimerLogo.svg';

const Footer = () => {
  return (
    <>
      <footer>
        <div className="FooterTop-container">
          <img src={FooterTop} className="footer-top" alt="Footer Top" />
        </div>
        <div className="Footer">
          <div className="container">
            <div>
              <span className="disclaimer_container">
                <img src={DisclaimerLogo} alt="Disclaimer Logo" />
                <DisclaimerComponent
                  clientName="zappynobackground"
                  textStyle={{
                    fontFamily: 'Lato',
                    fontSize: '12px',
                    color: '#333333',
                  }}
                  imageStyle={{
                    display: 'none',
                  }}
                  wrapperStyle={{
                    padding: '0px',
                  }}
                />
              </span>
            </div>
            <p style={{ fontSize: '12px' }}>
              <FormattedMessage
                id="footer.clientDisclaimer"
                defaultMessage="© 2024 Public Service Enterprise Group Incorporated. All Rights Reserved."
                description="© 2024 Public Service Enterprise Group Incorporated. All Rights Reserved."
              />
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
